var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _vm.node
    ? _c("sidebar-widget", {
        staticClass: "sidebar-assign",
        attrs: {
          id: "assignwidget",
          title: _vm.$gettext("Zuordnung"),
        },
        scopedSlots: _vm._u(
          [
            {
              key: "content",
              fn: function fn() {
                return [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: _vm.assignUrl,
                        title: _vm.$gettext(
                          "Angezeigte Veranstaltungen zuordnen"
                        ),
                      },
                      on: {
                        click: function click($event) {
                          $event.preventDefault()
                          return _vm.assignCurrentCourses.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c("studip-icon", {
                        attrs: {
                          shape: "arr_2right",
                        },
                      }),
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$gettext("Angezeigte Veranstaltungen zuordnen")
                          ) +
                          "\n        "
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          false,
          1018369757
        ),
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }